<app-breadcrumb [master]="'Terminale'" [parentName]="'Raporty'" [name]="'Import'"></app-breadcrumb>
<div class="terminals-import" fxLayout="column" fxLayoutGap="15px" [formGroup]="importForm"  *ngIf="(userPermissions | async)?.terminals.write">
  <div fxLayout="row" fxLayoutGap="15px" fxFlex="100">
    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100">
      <div fxLayout="row">
        <mat-card fxLayout="column" fxLayoutGap="15px" fxFlex="100">
          <div fxLayout="row">
            <h3>Dane importu</h3>
          </div>

          <app-file-drag-and-drop
            [multiple]="false"
            [generateOutput]="true"
            (fileSelected)="fileSelected($event)"
            [maxSize]="fileMaxSize"
            acceptMime="text/csv"
          ></app-file-drag-and-drop>

          <mat-error *ngIf="importForm.get('fileContent').hasError('backendError')">
            {{importForm.get('fileContent').getError('backendError')}}
          </mat-error>

        </mat-card>
      </div>
    </div>
  </div>

  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">
    <button (click)="import()" [class.spinner]="processingRequest"
            [disabled]="!importFormValid"
            mat-stroked-button color="primary"><mat-icon>publish</mat-icon> <span> Importuj</span></button>
  </div>
</div>

